const trips = {
  table: {
    headers: {
      from: 'מיקום איסוף',
      to: 'מיקום משלוח',
      seats: 'כמות פריטים',
      passenger: 'שם מקבל',
    },
  },
};

export default trips;
